import { html } from 'lit';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import { HelpCircle } from 'lucide';
import { DEFAULT_TIMEZONE, timeZoneOptions, TIJDZONE_UITLEG } from '@mv/models';
import { lucideIcon } from '../icon.js';
import { tipMove, tipHide } from '../utils/hover-tip.js';
import '../components/searchable-select.js';

/**
 * De uitleg in de zwever, met regeleinden zodat hij niet als één lange streep over het scherm
 * loopt. Zelfde tekst als onder het veld en als in de veldapp (TIJDZONE_UITLEG in @mv/models).
 */
export const TIJDZONE_TIP = TIJDZONE_UITLEG.replace(/\. /g, '.\n');

/**
 * Het tijdzoneveld van een project — één bron voor het aanmaak- en het bewerkformulier.
 *
 * De lijst komt uit `timeZoneOptions()` en draagt de huidige afstand tot UTC in het label. Die
 * afstand wordt nú berekend en staat niet als vaste tekst in een lijst: half Europa schuift
 * twee keer per jaar een uur op.
 *
 * @param {string} waarde    de gekozen tijdzone (leeg = de standaard)
 * @param {(tz: string) => void} kies  wordt geroepen met de nieuwe tijdzone
 */
export function tijdzoneVeld(waarde, kies) {
  const opties = timeZoneOptions();
  return html`
    <div class="form-group">
      <label class="form-label" style="display:flex; align-items:center; gap:6px;">
        Project tijdzone
        <span data-tip=${TIJDZONE_TIP} @mousemove=${tipMove} @mouseleave=${tipHide}
          style="display:inline-flex; vertical-align:-2px; color:var(--mv-text-sub,#6c757d); cursor:help;"
          >${unsafeSVG(lucideIcon(HelpCircle, 13))}</span>
      </label>
      <searchable-select
        placeholder="Kies of zoek…"
        style="--ss-text-transform:none; --ss-background:var(--mv-surface-alt,#F8F9FA);"
        .options=${opties}
        .value=${waarde || DEFAULT_TIMEZONE}
        @change=${(e) => kies(e.detail.value || DEFAULT_TIMEZONE)}>
      </searchable-select>
      <span style="display:block; margin-top:4px; color:var(--mv-text-muted); font-size:0.8rem; line-height:1.5;">
        ${TIJDZONE_UITLEG}
      </span>
    </div>
  `;
}
